import { Alert, AlertTitle, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  bannerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  alertContent: {
    width: '100%',
    display: 'flex',
    padding: 0,
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
}));

export const InvalidConfigurationBanner = () => {
  const classes = useStyles();

  return (
    <Box className={classes.bannerContainer}>
      <Alert severity="error" className={classes.alertContent}>
        <AlertTitle className={classes.alertContent}>Invalid Document Configuration</AlertTitle>
        Please contact your Trustate concierge
      </Alert>
    </Box>
  );
};
